import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import { useAsyncEffect, useObservable } from 'shared/hooks';
import { mediaTemporariesSaveQuery } from 'shared/queries';
import { MediaTemporaryModel } from 'shared/models';

import './styles.scss';

type PropsType = {
    fileToUpload?: File,
    src?: string,
    onUploaded?: (mediaTemporary: MediaTemporaryModel) => void,
    onDelete?: () => void
};

export const VmMedia = observer(function VmMedia( {
    fileToUpload,
    onUploaded = () => undefined,
    onDelete = () => undefined,
    src
}: PropsType) {
    const store = useObservable({
        isUploading: false,
        progress: 0
    });

    useAsyncEffect(async () => {
        if(!fileToUpload || store.isUploading){
            return;
        }

        store.set('isUploading', true);
        const response =await mediaTemporariesSaveQuery({
            file: fileToUpload,
            onUploadProgress: (progress) => {
                store.set('progress', progress)
            }
        });

        if(response.isSuccess && response.data) {
            onUploaded(new MediaTemporaryModel(response.data.item));
        }

    }, [fileToUpload, store]);

    if(!src && !fileToUpload) {
        return null;
    }

    const name = src || fileToUpload?.name || 'Файл';

    return (
        <div className="vm-media">
            {store.progress > 0 && (
                <div className="vm-media__progress">{store.progress}</div>
            )}
            <div className="vm-media__name">
                {name}
            </div>
        </div>
    );
});
